module.exports = __webpack_public_path__ + "img/基于场景的产品与服务bg@2x.1ec89012.png";